import React, { useState } from 'react';
import { Card, Spin } from 'antd';
import moment from 'moment';
import newsImagePlaceholder from './assets/news-placeholder.png';
import './newsContainer.scss';

const { Meta } = Card;

export default ({ title, thumbnail, contentSnippet, creator, publishedDate, url }) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = e => {
    setLoading(false);
    e.target.onerror = null;
    e.target.src = newsImagePlaceholder;
  };

  const handleClickCard = url => {
    window.open(url);
  };

  const date = publishedDate && moment(publishedDate).format('YYYY-MM-DD');
  const descriptionComponent = <div dangerouslySetInnerHTML={{ __html: contentSnippet }} />;

  return (
    <Card
      className="news-card"
      hoverable
      onClick={() => handleClickCard(url)}
      cover={
        <Spin spinning={loading}>
          <div className="news-img-container">
            <img alt={title} src={thumbnail} onLoad={handleImageLoad} onError={e => handleImageError(e)} />
          </div>
        </Spin>
      }
    >
      <Meta title={title} description={descriptionComponent} />
      <div className="news-detailed-info">
        <div className="author">BY {creator || 'LMI Group'}</div>
        <div className="date">{date}</div>
      </div>
    </Card>
  );
};
